import React from 'react';
import {
  AvatarStyled,
  AvatarImgStyled,
  AvatarNameStyled,
} from './avatar.styled';

// TODO: alex - add Enum for sizes
export interface AvatarProps {
  size?: 'small' | 'normal' | 'medium' | 'large';
  src?: string;
  alt?: string;
  name?: string;
  selected?: boolean;
  onClick?: () => void;
}

const Avatar = ({
  onClick,
  src,
  alt,
  name = '?',
  size,
  ...rest
}: AvatarProps) => {
  const fallBackChar = name.charAt(0).toUpperCase();
  let bg = '#0f2eff';
  if (
    [
      'A',
      'C',
      'E',
      'G',
      'I',
      'K',
      'M',
      'O',
      'Q',
      'S',
      'U',
      'W',
      'Y',
      'Z',
    ].includes(fallBackChar)
  ) {
    bg = '#FFCB00';
  }
  if (name === '?') bg = 'transparent';
  return (
    <AvatarStyled bg={bg} onClick={onClick} size={size} {...rest}>
      {src ? (
        <AvatarImgStyled src={src} alt={alt} />
      ) : (
        <AvatarNameStyled size={size}>{fallBackChar}</AvatarNameStyled>
      )}
    </AvatarStyled>
  );
};

Avatar.defaultProps = {
  size: 'normal',
};

export default Avatar;
